import React, {useState, useEffect, useRef} from 'react';
import {candidatePhone} from './candidateDisplay';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {Panel} from "primereact/panel";
import CandidateProfileFields from './CandidateProfileSection';
import {candidateSearchQuery} from './candidateProfileSchema';
import axios from "axios";
import CandidateMergeDialog, {retainOtherPageSelection} from './CandidateMergeDialog';

const CandidateListComponent = (props) => {

  const {t, onDetailedSearchActiveChange} = props;
  const history = useHistory();
  const {entity} = useParams();
  const [candidates, setCandidates] = useState([]);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [mergeVisible, setMergeVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [detailedSearchVisible, setDetailedSearchVisible] = useState(false);
  const [detailedSearchQuery, setDetailedSearchQuery] = useState('');
  const isDetailedSearchActive = React.useMemo(() => {
    return (detailedSearchQuery || '').toString().trim().length > 0;
  }, [detailedSearchQuery]);
  
  const [searchValues, setSearchValues] = useState({});

  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  const loadSequence = useRef(0);
  const loadLazyData = () => {
    const sequence = ++loadSequence.current;
    setLoading(true);
      const baseQuery = window.App.transformQueryParams(lazyParams);
      const query = mergeQueries(baseQuery, detailedSearchQuery);
      apiCall('get', '/api/v2/candidate' + query)
        .then(response => {
          if (sequence !== loadSequence.current) return;
          setTotalRecords(response.data.data.total_item_count);
          setCandidates(response.data.data.items)
        })
        .catch(error => {
          if (sequence !== loadSequence.current) return;
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          if (sequence === loadSequence.current) setLoading(false);
        })
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => {setRows(e.value); setLazyParams(previous => ({...previous, rows: e.value, first: 0, page: 0}));}}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const buildDetailedSearchQuery = () => candidateSearchQuery(searchValues);

  const normalizeQuery = (q) => {
    const s = (q || '').toString().trim();
    if (!s) return '';
    return s.startsWith('?') ? s.slice(1) : s;
  };

  const mergeQueries = (baseQuery, extraQuery) => {
    const a = normalizeQuery(baseQuery);
    const b = normalizeQuery(extraQuery);
    const merged = [a, b].filter(Boolean).join('&');
    return merged ? `?${merged}` : '';
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_recruitment_candidate_write') &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if(entity === 'candidate') {
                      history.push('/recruitment/candidate/update/' + rowData.id)
                    }
                  }}/>
        }
        <Button
        icon="pi pi-eye"
        className="p-button p-mr-2"
        tooltip={t('view')}
        tooltipOptions={{ position: 'left' }}
        onClick={() => {
          history.push('/recruitment/candidate/read/' + rowData.id);
        }}
      />
        {localStorage.getItem('roles').toString().includes('role_recruitment_candidate_write') &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      setLoading(true);
                      apiCall('delete', '/api/v2/candidate/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres törlés!');
                          window.App.setState({rerenderCandidateList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        }
      </React.Fragment>
    );
  }

  useEffect(() => {
    loadLazyData();
    return () => { loadSequence.current += 1; };
  }, [lazyParams, detailedSearchQuery, window.App.state.rerenderCandidateList])

  useEffect(() => {
    if (typeof onDetailedSearchActiveChange === 'function') {
      onDetailedSearchActiveChange(isDetailedSearchActive);
    }
  }, [isDetailedSearchActive, onDetailedSearchActiveChange]);

  return (
    <>
      <div className={"p-grid p-mb-2"}>
        <div className={"p-col-12 p-text-right"}>
          <Button
            type="button"
            label={t('detailedSearch')}
            icon={isDetailedSearchActive ? "pi pi-filter-fill" : "pi pi-filter"}
            className="p-button-outlined"
            onClick={() => setDetailedSearchVisible(!detailedSearchVisible)}
          />
        </div>
      </div>

      {detailedSearchVisible && <Panel className="p-mb-2 candidate-ds-panel">
        <CandidateProfileFields mode="search" values={searchValues} t={t} onChange={(name, value) => setSearchValues(previous => ({...previous, [name]: value}))}/>
        <div className="p-text-right">
          <Button label={t('dsClearCriteria')} icon="pi pi-times" className="p-button-danger p-mr-2" onClick={() => {
            setSearchValues({}); setDetailedSearchQuery(''); setLazyParams({...lazyParams, first: 0, page: 0});
          }}/>
          <Button label={t('dsSearch')} icon="pi pi-search" onClick={() => {
            setDetailedSearchQuery(buildDetailedSearchQuery()); setLazyParams({...lazyParams, first: 0, page: 0});
          }}/>
        </div>
      </Panel>}

      <DataTable size={localStorage.getItem('scale')}
                emptyMessage={t('noResults')}
                value={candidates} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                paginatorTemplate={pager} rows={rows}
                autoLayout={true}
                filterDisplay="row"
                responsiveLayout="scroll"
                stripedRows
                ref={dt}
                dataKey="id"
                selection={selectedCandidates}
                onSelectionChange={e => setSelectedCandidates(previous => retainOtherPageSelection(previous, candidates, e.value))}
                selectionPageOnly
      >
        <Column selectionMode="multiple" headerStyle={{width: '3rem'}}/>
        <Column field="name" header={t('columnName')} bodyClassName="col-body-font-bold" sortable filter></Column>

        <Column field="email" header={t('candidateProfile.fields.email')} sortable/>
        <Column field="phone" header={t('candidateProfile.fields.phone')} body={candidatePhone}/>
        <Column field="birthday" header={t('candidateProfile.fields.birthday')} sortable body={row => row.birthday ? window.App.formatDateValue(row.birthday.slice(0, 10)) : '—'}/>
        <Column field="city.name" header={t('candidateProfile.fields.city')}/>
        <Column field="source" header={t('candidateProfile.fields.source')} sortable/>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
      <div className="p-mt-3 p-d-flex p-ai-center" style={{gap: 12}}>
        <span>{t('candidateMerge.selected', {count: selectedCandidates.length})}</span>
        {selectedCandidates.length > 0 && <Button className="p-button-text" label={t('candidateMerge.clear')} onClick={() => setSelectedCandidates([])}/>}
        {(localStorage.getItem('roles') || '').includes('role_recruitment_candidate_write') &&
          <Button label={t('candidateMerge.title')} icon="pi pi-clone" disabled={selectedCandidates.length < 2 || loading} onClick={() => setMergeVisible(true)}/>}
      </div>
      {mergeVisible && <CandidateMergeDialog candidates={selectedCandidates} t={t} onHide={() => setMergeVisible(false)} onMerged={() => {
        setMergeVisible(false); setSelectedCandidates([]); loadLazyData();
        window.App.toastShow('success', t('candidateMerge.success'));
      }}/>}
    </>
  )

}
export default withTranslation('common')(CandidateListComponent);
